import { Box, Heading, Table, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react"
import type { Kpi, RatingDatapoints } from "@esgt/types"
import { MethodI18nFragment } from "components/I18nText"
import { formatValue } from "lib/helpers/formatValue"
import { getBreakdownRows } from "./getBreakdownRows"

interface BreakdownTableProps {
  kpi: Kpi
  datapoints: RatingDatapoints
}

export const BreakdownTable = ({ kpi, datapoints }: BreakdownTableProps) => {
  if (!kpi.breakdown) return null

  const { suffixSegments, valuePrefixes } = kpi.breakdown
  const rows = getBreakdownRows(datapoints, kpi.breakdown)

  return (
    <Box p="32px" overflow="auto" flex={1}>
      <Heading size="h4" mb="16px">
        <MethodI18nFragment text={kpi.name} />
      </Heading>

      {!rows?.length ? (
        <Text color="neutral.600">Ingen data registrert ennå.</Text>
      ) : (
        <Table size="sm" variant="simple">
          <Thead>
            <Tr>
              {suffixSegments.map((seg, i) => (
                <Th key={i}>
                  <MethodI18nFragment text={seg.header} />
                </Th>
              ))}
              {valuePrefixes.map((vp, i) => (
                <Th key={`vp-${i}`} textAlign="right">
                  <MethodI18nFragment text={vp.header} />
                </Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {rows.map((row) => (
              <Tr key={row.key}>
                {row.columns.map((col, i) => (
                  <Td key={i}>{col}</Td>
                ))}
                {row.values.map((val, i) => (
                  <Td key={`v-${i}`} textAlign="right">
                    {formatValue(val)}
                  </Td>
                ))}
              </Tr>
            ))}
          </Tbody>
        </Table>
      )}
    </Box>
  )
}
